import { MAX_4U_WIDTH, MAX_NARROW_WIDTH_PRINT } from './constants';
/**
 * Processes and build the chart series data.
 */
export default function processSeries(options) {
  // Prepare series for Highcharts.
  options.originalSeries = options.series.map(currentSeries => currentSeries.data.map(data => Object.assign({}, data)));
  let data = options.series.map(item => {
    let series = {
      data: item.data,
      name: item.name,
      step: options.step ? 'left' : null,
      markdown: item.markdown,
      showInLegend: item.showInLegend,
      animation: false,
      color: item.color || options.defaults.colors[0],
      dashStyle: options.step || item.dashStyle !== 'dotted' ? 'solid' : 'dot',
      negativeColor: options.colorMode === 'THRESHOLD' && (options.type === 'column' || options.type === 'bar') ?
        item.negativeColor || options.defaults.colors[1]
        :
        null,
      events: {
        legendItemClick: function () { return false; }
      },
      turboThreshold: 0,
      states: {
        hover: {
          enabled: options.type === 'line'
        }
      }
    };
    return series;
  });
  if (options.categoriesAreMonthly && options.type === 'column') {
    startOfMonth(data);
  }
  // Customize the data for the particular chart type.
  switch (options.type) {
    case 'pie':
      data = data.slice(0, 1);
      break;
    case 'bar':
      // Save data to do this later, when options.styles.lineHeight is known.
      // return truncateData(options, data);
      options.series = data;//sortData(data, options);
      return options;
    case 'column':
      const forceLegendTop = ((options.print && options.width <= MAX_NARROW_WIDTH_PRINT) ||
       (!options.print && options.width <= MAX_4U_WIDTH));
      const rightLegend = options.legend.layout === 'right' && !forceLegendTop;
      data = options.stacking ? reverseDataOrder(data, rightLegend) : data;
      break;
    case 'line':
      data = reverseDataOrder(data);
      break;
  }
  
  options.series = data;//sortData(data, options);
  for (let i = 0; i < options.series.length; i++) {
    let seriesData = options.series[i].data;
    for (let z = 0; z < seriesData.length; z++) {
      seriesData[z].index = z;
    }
  }
  return options;
}

// For line charts, first column should be top layer. This also reverses the
// legend items, so that must be fixed separately.
function reverseDataOrder(data, reverseLegend = false) {
  const dataLen = data.length;
  data.forEach((item, index) => {
    item.index = dataLen - index - 1;
    item.legendIndex = reverseLegend ? dataLen - index - 1 : index;
  });
  return data;
}

function startOfMonth(data) {
  // for column charts with one date per month, shift x value to first of month
  data.forEach(series => {
    series.data.forEach(position => {
      const date = new Date(position.x);
      date.setUTCDate(1);
      position.x = date.valueOf();
    })
  })
}


// For horizontal bar charts, removes data to improve visual appearance.
export function truncateData(options, data) {
  // Guestimate the maximum data rows that will fit.
  const maxRows = Math.floor(options.height /
    (parseFloat(options.styles.lineHeight.large) * 1.5));
  // Remove data so rows does not exceed maxRows.
  const overflow = Math.ceil(data[0].data.length / maxRows);
  const originalCategories = options.categories ?
    options.categories.slice() : null;
  let categories = [];
  if (overflow > 1) {
    data.forEach((item, index) => {
      let items = [];
      let n = 0;
      while (n < item.data.length) {
        if (index === 0 && options.categories) {
          categories.push(originalCategories[n]);
          options.categories = categories;
        }
        items.push(item.data[n]);
        n += overflow;
      }
      item.data = items;
    });
  }
  options.series = data;
  return options;
}



// WEBPACK FOOTER //
// ./src/chart/data/processSeries.js